module.exports = __webpack_public_path__ + "static/img/popup_bg.83fafec9.png";